<template>
  <!-- 新解析器 -->
  <div class="">
    <v-dialog
      class="popbox"
      name="dialog2"
      v-model="isShow"
      :title="dialogTitle"
      close-on-click-modal
      :modal="true"
      :width="668"
      @open="open"
      @after-close="handleAfterClose"
      @confirm="handleConfirm"
      append-to-body
    >

      <v-form ref="form" :model="ruleForm" :rules="rules">

        <v-form-item  prop="analysis_name" >
          <template slot="label">
            <span class="required">*</span>
            <span>解析器名称</span>
          </template>
          <v-input type="text" name="analysis_name" v-model="ruleForm.analysis_name"></v-input>
        </v-form-item>
        <v-form-item  prop="open_status" >
          <template slot="label">
            <span class="required">*</span>
            <span>开关状态</span>
          </template>
          <v-radio class="options" v-model="ruleForm.open_status" name="open_status" :options="statusOptions"></v-radio>
        </v-form-item>
        <v-form-item  prop="source_id" >
          <template slot="label">
            <span class="required">*</span>
            <span>数据源</span>
          </template>
          <v-select id="source_id" name="source_id" :placeholder="sourceIdOptins.length > 0 ? '请选择' : '请先新建数据源'" v-model="ruleForm.source_id" :options="sourceIdOptins"></v-select>
        </v-form-item>
        <v-form-item  prop="dest_id" >
          <template slot="label">
            <span class="required">*</span>
            <span>数据目的</span>
          </template>
          <v-select id="dest_id"  name="dest_id" :placeholder="destIdOptins.length > 0 ? '请选择' : '请先新建数据目的'" v-model="ruleForm.dest_id" :options="destIdOptins"></v-select>
        </v-form-item>
        <v-form-item  prop="analysis_desc" >
          <template slot="label">
            <span class="required">*</span>
            <span>描述</span>
          </template>
          <v-input type="textarea" class="remarks" name="analysis_desc" :maxlength="200" v-model="ruleForm.analysis_desc" show-word-limit></v-input>
        </v-form-item>
      </v-form>
    </v-dialog>

  </div>

</template>

<script>
import { copy } from '@/common/libs/utils';

export default {
  components: {},
  props:{
  showInputDialog:{
    type:Boolean,
    default: false
  },
},
  data() {
    return {
      rules: {
        analysis_name: copy([{
          type: "nameInput"
        }]),
      },
      ruleForm:{
        analysis_name: "",  //名称
        analysis_desc: "",   //描述
        open_status: 1, //开关状态
        app_id: sessionStorage.getItem("appid") || "",
        source_id: '', //数据源id
        dest_id: ''   //数据目的id
      },
      statusOptions: [
        {
          label: '开启',
          value: 1
        },
        {
          label: '关闭',
          value: 2
        }
      ],
      sourceIdOptins: [],
      destIdOptins: [],
      dialogTitle: "创建解析器",

      isShow:false,
    };
  },
  created() {
  },
  watch:{
    showInputDialog(newVal){
      this.isShow = newVal
    }
  },
  methods: {
    open(){
      this.getSourceData()
      this.getDestData()
    },
    async getSourceData(){
      const subData = {
        app_id: sessionStorage.getItem("appid") || "",
      };
      const res = await this.$getData(
        "/td/td-iot-api/iot/rule/source/tiny-list/v1",
        subData
      );
      if(res.code === 0){
        this.sourceIdOptins = res.data.list.map((item) =>{
          return {
            label: item.source_name,
            value: item.id,
          }
        })
      }
    },
    async getDestData(){
      const subData = {
        app_id: sessionStorage.getItem("appid") || "",
      };
      const res = await this.$getData(
        "/td/td-iot-api/iot/rule/dest/tiny-list/v1",
        subData
      );
      if(res.code === 0){
        this.destIdOptins = res.data.list.map((item) =>{
          return {
            label: item.dest_name,
            value: item.id,
          }
        })
      }
    },
    handleConfirm() {
      const valid = this.$refs.form.submitForm();
      if (valid === false) {
        return;
      }
      let submitData = { ...this.ruleForm };
      this.$post("/td/td-iot-api/iot/rule/analysis/v1", submitData, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.$emit('getData')
          this.$message.success(res.msg);
        }
        else {
          this.$message.error(res.msg);
        }
      });
      this.$emit('update:showInputDialog',false)
      Object.assign(this.$data, this.$options.data())
    },
    handleAfterClose() {
      this.$emit('update:showInputDialog',false)
      Object.assign(this.$data, this.$options.data())
    }
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
</style>
